import React from "react";
import styles from "./OrderInitiatePage.module.css";

const PCT_OF_MARGIN_TITLE = "% of margin required";

function percentToneClass(pctStr) {
  if (pctStr == null || pctStr === "" || pctStr === "—") return styles.neutral;
  const s = String(pctStr);
  if (s.startsWith("-") || s.startsWith("−")) return styles.negative;
  return styles.positive;
}

/** "+12.34%" / "-8%" → "12.34" / "-8" for display next to the value (caller adds %). */
function pctNumberOnly(pctStr) {
  if (pctStr == null || pctStr === "" || pctStr === "—") return null;
  const s = String(pctStr).replace(/%/g, "").replace(/^\+/, "").trim();
  if (!s) return null;
  const lower = s.toLowerCase();
  if (lower === "inf" || lower === "infinity" || lower === "unlimited" || lower === "-inf" || lower === "-infinity") {
    return null;
  }
  return s;
}

function ProfitValueWithPct({ value, pctStr }) {
  const pctNum = pctNumberOnly(pctStr);
  return (
    <div className={styles.profitCardValue}>
      {value}
      {pctNum ? (
        <span
          className={`${styles.profitCardPercent} ${percentToneClass(pctStr)}`}
          title={PCT_OF_MARGIN_TITLE}
        >
          {" "}({pctNum}%)
        </span>
      ) : null}
    </div>
  );
}

function TopMetricsRow({
  maxProfitVal,
  minProfitVal,
  maxProfitPct = "—",
  maxLossPct = "—",
  metricsGrid,
}) {
  return (
    <div className={styles.topMetricsSection}>
      <div className={styles.topMetricsRow}>
        <div className={`${styles.profitCard} ${styles.profitCardMax}`}>
          <div className={styles.profitCardHeader}>
            <span className={styles.profitCardTitle}>Max Profit</span>
          </div>
          <ProfitValueWithPct value={maxProfitVal} pctStr={maxProfitPct} />
        </div>
        <div className={`${styles.profitCard} ${styles.profitCardLoss}`}>
          <div className={styles.profitCardHeader}>
            <span className={styles.profitCardTitle}>Max Loss</span>
          </div>
          <ProfitValueWithPct value={minProfitVal} pctStr={maxLossPct} />
        </div>
        {metricsGrid.map((item) => (
          <div
            key={item.label}
            className={`${styles.metricsBlock}${item.growToFit ? ` ${styles.metricsBlockGrow}` : ""}`}
          >
            <div className={styles.metricsValue} title={item.value !== "—" ? String(item.value) : undefined}>
              {item.value}
            </div>
            <div className={styles.metricsLabel}>{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default React.memo(TopMetricsRow);
